export const topRegions = {
  status: 'success',
  data: [
    {
      state: 'Lagos',
      country: 'Nigeria',
      total_sales: 200,
      top_region: [
        {
          region: 'Surulere',
          sales: 50,
        },
        {
          region: 'Ketu',
          sales: 50,
        },
        {
          region: 'Ogudu',
          sales: 50,
        },
        {
          region: 'Ikeja',
          sales: 50,
        },
      ],
    },
    {
      state: 'Oyo',
      country: 'Nigeria',
      total_sales: 200,
      top_region: [
        {
          region: 'Apata',
          sales: 50,
        },
        {
          region: 'Apete',
          sales: 50,
        },
        {
          region: 'Ring Road',
          sales: 50,
        },
        {
          region: 'Felele',
          sales: 50,
        },
      ],
    },
  ],
};
